// extracted by mini-css-extract-plugin
module.exports = {"language-switcher":"LanguageSwitcher_language-switcher__GE9tL","selected-language":"LanguageSwitcher_selected-language__3x3fF","caret":"LanguageSwitcher_caret__tBhh7"};